import 'assets/styles/default.scss';
import LayoutProvider from 'contexts/layoutContext/LayoutContext';
import Layout from 'layout/Layout';
import 'plataforma-fundacao-componentes/dist/index.css';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import Routes from 'routes/Routes';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <BrowserRouter basename='/registro'>
    <LayoutProvider>
      <Layout>
        <Routes />
      </Layout>
    </LayoutProvider>
  </BrowserRouter>
);
